import { ShieldCheck } from "lucide-react";

// Small brand-trust badge: icon + "Family Safe AI".
export function FamilySafeBadge({ className = "" }) {
  return (
    <span
      data-testid="family-safe-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs font-semibold text-emerald-700 dark:text-emerald-400 ${className}`}
    >
      <ShieldCheck className="h-3.5 w-3.5" aria-hidden="true" />
      Family Safe AI
    </span>
  );
}

// Slim site-wide footer strip carrying the Family Safe badge.
export function FamilySafeBar() {
  return (
    <div
      data-testid="family-safe-bar"
      className="border-t border-border bg-background/60 py-3 px-6 flex items-center justify-center gap-2"
    >
      <FamilySafeBadge />
      <span className="text-xs text-muted-foreground">
        Every course is filtered for respectful, educational, all-ages content.
      </span>
    </div>
  );
}

export default FamilySafeBadge;
